var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopify-auth"},[_c('img',{attrs:{"src":require("@/assets/images/shopify/shopify.jpeg"),"alt":"","srcset":""}}),_c('p',[_vm._v(_vm._s(_vm.$lang('订阅中'))+"......")])])}
var staticRenderFns = []

export { render, staticRenderFns }